import { render, staticRenderFns } from "./prizes.vue?vue&type=template&id=5dea931b"
import script from "./prizes.vue?vue&type=script&lang=js"
export * from "./prizes.vue?vue&type=script&lang=js"
import style0 from "./prizes.vue?vue&type=style&index=0&id=5dea931b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports